// Simple global state for app-wide flags
// Prefer importing this module over using window directly,
// but we also mirror to window for legacy/global consumers.

export const appState = {
  isFirstCanvassCreated: undefined, // undefined = unknown, boolean once resolved
  client: undefined,
  isTutorialComp: undefined,
};

export const setIsFirstCanvassCreated = (val) => {
  appState.isFirstCanvassCreated = Boolean(val);
  if (appState.client) appState.client.isFirstCanvassComp = Boolean(val);
  if (typeof window !== 'undefined') {
    window.IsFirstCanvassCreated = appState.isFirstCanvassCreated;
  }
};

export const getIsFirstCanvassCreated = () => {
  if (appState.client && typeof appState.client.isFirstCanvassComp !== 'undefined') {
    appState.isFirstCanvassCreated = Boolean(appState.client.isFirstCanvassComp);
    if (typeof window !== 'undefined') window.IsFirstCanvassCreated = appState.isFirstCanvassCreated;
    return appState.isFirstCanvassCreated;
  }
  if (typeof appState.isFirstCanvassCreated !== 'undefined') return appState.isFirstCanvassCreated;
  if (typeof window !== 'undefined' && typeof window.IsFirstCanvassCreated !== 'undefined') {
    appState.isFirstCanvassCreated = Boolean(window.IsFirstCanvassCreated);
    return appState.isFirstCanvassCreated;
  }
  return undefined; // not yet known
};

export const setClient = (client) => {
  appState.client = client || null;
  if (typeof window !== 'undefined') {
    window.AugustClient = appState.client;
  }
};

export const getClient = () => {
  if (typeof appState.client !== 'undefined') return appState.client;
  if (typeof window !== 'undefined' && typeof window.AugustClient !== 'undefined') {
    appState.client = window.AugustClient;
    return appState.client;
  }
  return undefined;
};

export const setIsTutorialComp = (val) => {
  appState.isTutorialComp = Boolean(val);
  if (appState.client) appState.client.isTutorialComp = Boolean(val);
  if (typeof window !== 'undefined') {
    window.IsTutorialComp = appState.isTutorialComp;
  }
};

export const getIsTutorialComp = () => {
  if (appState.client && typeof appState.client.isTutorialComp !== 'undefined') {
    appState.isTutorialComp = Boolean(appState.client.isTutorialComp);
    if (typeof window !== 'undefined') window.IsTutorialComp = appState.isTutorialComp;
    return appState.isTutorialComp;
  }
  if (typeof appState.isTutorialComp !== 'undefined') return appState.isTutorialComp;
  if (typeof window !== 'undefined' && typeof window.IsTutorialComp !== 'undefined') {
    appState.isTutorialComp = Boolean(window.IsTutorialComp);
    return appState.isTutorialComp;
  }
  return undefined;
};
